import { Component, OnInit, ViewChild, AfterViewInit, Inject} from '@angular/core';
import {MatTable, MatTableDataSource} from '@angular/material/table';
import {UntypedFormControl, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import {MatPaginator} from '@angular/material/paginator';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Globals } from 'src/app/service/global';
import { AttendeeService } from 'src/app/service/attendee.service';
import { PermissionService } from 'src/app/service/permission.service';
import { UtilityService } from 'src/app/service/utility.service';
export interface PeriodicElement {
  attendeeId: number;
  attendeeName: string;
  agendaTitle: string;
  logTime: string;
  logType: string;
  reason: string;
  action: string;
}


@Component({
  selector: 'app-track-attendee-dialog',
  templateUrl: './track-attendee-dialog.component.html',
  styleUrls: ['./track-attendee-dialog.component.css']
})
export class TrackAttendeeDialogComponent implements OnInit {
  selected = new UntypedFormControl();
  time = new UntypedFormControl();
  reason = new UntypedFormControl();
  agendaSelection = new UntypedFormControl();
  addAttendee = new UntypedFormControl();
  typeSelection = new UntypedFormControl();
   ELEMENT_DATA: PeriodicElement[] = [];
  displayedColumns: string[] = ['attendeeName', 'agendaTitle', 'logTime', 'logType', 'reason', 'action'];
  dataSource = new MatTableDataSource<PeriodicElement>(this.ELEMENT_DATA);
  showTrackAttendeeEditForm = false
  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  editedReason:any
  attendeeName : any;
  agendaContent : any;
  type : any;
  logData: any;
  agendaList :any;
  agendaTitle :any
  defaultAttendeeName: any;
  defaultMeetingId: any;
  attendeeLogData: any;
  addAttendeeName: any;
  addAttendeeId: any;
  addMeetingId: any;
  meetingResponse: any;
  paginatorFlag :any = false;
  // logArray: any =[];
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  getAttendee(e : any){
    this.attendeeName = e.target.value
  }

  getAgenda(e : any){
    this.agendaContent = e.target.value
  }

  getTime(e: any){
    this.time = e.target.value
  }

  getType(e: any){
    this.type = e.target.value
  }

  getReason(e : any){
    this.reason = e.target.value
  }
  
  addToAttendeeTraker(){
    var logArray: any = [];
    // let newObj = {
    //   attendeeId: 100,
    //   attendeeName : this.selected.value,
    //   agendaTitle : this.agendaSelection.value,
    //   logTime : this.time,
    //   logType : this.typeSelection.value,
    //   reason : this.reason,
    //   action : 'edit'
    // }
    let newObj = {
      "attendeeName": this.addAttendeeName,
      "attendeeId": this.addAttendeeId,
      "attendeeUserId" : this.globals.userId,
      "agendaTitle" : this.agendaSelection.value,
      "currentTime" : this.time.value,
      "logType" : this.typeSelection.value,
      "lastModifiedBy": this.globals.userId,
      "reason" : this.reason.value,
      "orgCode" : this.globals.orgCode,
      "meetingId" :this.addMeetingId,
      "attendeeLogId": "",
      "absentType" :"Time",
      "timeZone" : this.globals.vTimeZone,
      "meetingDate": this.meetingResponse.meetingDateFullFormat
    }
    // this.ELEMENT_DATA.push(newObj)
    
    this.attendeeService.saveAttendeeLog(newObj).subscribe((data: any) => {
      this.attendeeService.getAttendeeLog(data.attendeeId).subscribe((data: any) => {
        this.attendeeLogData = data.body;
        this.attendeeLogData.forEach((element: any) => {
          var logTime = element.logTime;
           var time = new Date();
          var currentTime = time.getHours() + ":" + time.getMinutes() + ":" + time.getSeconds();
          var curSysDate = new Date(logTime);
          var meetUtc = curSysDate.getTime() + (curSysDate.getTimezoneOffset() * 60000);//current utc date with time
          var fullDate = new Date(meetUtc + (3600000 * (this.globals.vTimeZoneIntOffset)));//convert utc to corresponding timezone
          var hour = this.addZero(fullDate.getHours());
          var minutes = this.addZero(fullDate.getMinutes());
          var seconds = this.addZero(fullDate.getSeconds());
          var currentTime = hour + ":" + minutes + ":" + seconds;
          element.logTime = currentTime;
          logArray.push(element);
        });
        this.dataSource = new MatTableDataSource<PeriodicElement>(logArray);
        this.dataSource.paginator = this.paginator;
        // this.addAttendee.setValue("");
        this.agendaSelection.setValue("");
        this.typeSelection.setValue("");
        this.time.setValue("");
        this.reason.setValue("") ;
        this.attendeeService.sendData(newObj);
    });

    });

  }

  // addData() {
  //   const randomElementIndex = Math.floor(Math.random() * ELEMENT_DATA.length);
  //   this.dataSource.push(ELEMENT_DATA[randomElementIndex]);
  //   this.table.renderRows();
  // }

  // removeData() {
  //   this.dataSource.pop();
  //   this.table.renderRows();
  // }

  triggerEditAttendee(data : any){
 
    
    this.editedReason = data.reason
    this.agendaTitle = data.agendaTitle
    var roleFlag = this.permissionService.checkRoleRightsWithAlert(this.utility.featureList.PARTICIPANTS,this.utility.permissionType.MODIFY);
    
    if(!roleFlag){
      return;
    }
    $('#attendee'+data._id).css("display","none");
    $('#edit-attendee'+data._id).css("display","")

    $('#agenda'+data._id).css("display","none");
    $('#edit-agenda'+data._id).css("display","")

    $('#reason'+data._id).css("display","none");
    $('#edit-reason'+data._id).css("display","")

    $('#icon'+data._id).css("display","none");
    $('#edit-icon-save'+data._id).css("display","")
    $('#edit-icon-close'+data._id).css("display","")
    
  }

  saveEdit(id : any){
    // window.alert("saved")

    var roleFlag = this.permissionService.checkRoleRightsWithAlert(this.utility.featureList.PARTICIPANTS,this.utility.permissionType.MODIFY);
    
    if(!roleFlag){
      return;
    }
    $('#attendee'+id).css("display","");
    $('#edit-attendee'+id).css("display","none")

    $('#agenda'+id).css("display","");
    $('#edit-agenda'+id).css("display","none")

    $('#reason'+id).css("display","");
    $('#edit-reason'+id).css("display","none")

    $('#icon'+id).css("display","");
    $('#edit-icon-save'+id).css("display","none")
    $('#edit-icon-close'+id).css("display","none")
    this.logData.forEach((element:any) => {
     this.defaultAttendeeName= element.attendeeName;
     this.defaultMeetingId=element.meetingId;
    });
    var attendeeLogJson={

      "attendeeName":this.defaultAttendeeName,
      "meetingId":this.defaultMeetingId,
      "agendaTitle":this.agendaTitle,
      "reason":this.editedReason,
      "lastModifiedBy": this.globals.userId,
      "attendeeLogId": id
    }
    this.attendeeService.updateAttendeeLog(attendeeLogJson).subscribe((data: any) => {
      var logArray: any = [];

      this.attendeeService.getAttendeeLog(data.body.attendeeId).subscribe((data: any) => {
        this.attendeeLogData = data.body;
        this.attendeeLogData.forEach((element: any) => {
          var logTime = element.logTime;
           var time = new Date();
          var currentTime = time.getHours() + ":" + time.getMinutes() + ":" + time.getSeconds();
          var curSysDate = new Date(logTime);
          var meetUtc = curSysDate.getTime() + (curSysDate.getTimezoneOffset() * 60000);//current utc date with time
          var fullDate = new Date(meetUtc + (3600000 * (this.globals.vTimeZoneIntOffset)));//convert utc to corresponding timezone
          var hour = this.addZero(fullDate.getHours());
          var minutes = this.addZero(fullDate.getMinutes());
          var seconds = this.addZero(fullDate.getSeconds());
          var currentTime = hour + ":" + minutes + ":" + seconds;
          element.logTime = currentTime;
          logArray.push(element);
        });
        this.dataSource = new MatTableDataSource<PeriodicElement>(logArray);
        this.dataSource.paginator = this.paginator;
        this.paginatorFlag= true;
        this.agendaTitle=""
        this.editedReason = ""    
    });
  });
  }



  addZero(i: any) {
    if (i < 10) {
      i = "0" + i;
    }
    return i;
  }

  cancelEdit(id : any){
    $('#attendee'+id).css("display","");
    $('#edit-attendee'+id).css("display","none")

    $('#agenda'+id).css("display","");
    $('#edit-agenda'+id).css("display","none")

    $('#reason'+id).css("display","");
    $('#edit-reason'+id).css("display","none")

    $('#icon'+id).css("display","");
    $('#edit-icon-save'+id).css("display","none")
    $('#edit-icon-close'+id).css("display","none")
  }

  showTrackAttendeeForm(bool : any){
    var roleFlag = this.permissionService.checkRoleRightsWithAlert(this.utility.featureList.PARTICIPANTS,this.utility.permissionType.READ);
    
    if(!roleFlag){
      return;
    }
    this.showTrackAttendeeEditForm = bool
  }

  hideTrackAttendeeForm(bool : any){
    this.showTrackAttendeeEditForm = bool
  }

  constructor(private permissionService:PermissionService ,@Inject(MAT_DIALOG_DATA) data: any,public globals:Globals,public attendeeService:AttendeeService,private utility:UtilityService) {
    this.agendaList = data.agendaList;
    this.logData = data.logData
    this.meetingResponse = data.meetingResponse;
    this.dataSource = new MatTableDataSource<PeriodicElement>(data.logData);

    // this.logData.forEach((attendeeList:any) => {
      this.addAttendeeName =data.attendeeObj.attendeeName
      this.addAttendeeId =data.attendeeObj.attendeeId
      this.addMeetingId =data.attendeeObj.meetingId
    // });
    this.addAttendee.setValue(this.addAttendeeName)

   }

  ngOnInit(): void {
  }

}
